var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManualSynonymLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 100,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#manual-synonym-lock_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 47,
  r: 45,
  fill: "#FFFBF3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFDCA8",
  fillRule: "evenodd",
  d: "M33.95 87.911c0 1.074-.866 1.95-1.95 1.95 1.084 0 1.95.868 1.95 1.951 0-1.073.867-1.95 1.951-1.95a1.95 1.95 0 0 1-1.95-1.95m0-3.911c0 1.073-.866 1.95-1.95 1.95 1.084 0 1.95.878 1.95 1.951 0-1.073.867-1.95 1.951-1.95A1.95 1.95 0 0 1 33.951 84m3.91 0c0 1.073-.866 1.95-1.95 1.95 1.073 0 1.95.878 1.95 1.951 0-1.073.867-1.95 1.951-1.95A1.95 1.95 0 0 1 37.861 84m1.962 1.95c1.084 0 1.95-.877 1.95-1.95 0 1.084.878 1.95 1.951 1.95-1.084 0-1.95.878-1.95 1.951 0-1.073-.878-1.95-1.951-1.95m-3.91 3.912c1.084 0 1.95-.877 1.95-1.95 0 1.083.878 1.95 1.951 1.95-1.084 0-1.95.877-1.95 1.95 0-1.083-.878-1.95-1.951-1.95m5.862-1.95c0 1.073-.867 1.95-1.95 1.95 1.073 0 1.95.867 1.95 1.95a1.95 1.95 0 0 1 1.95-1.95 1.95 1.95 0 0 1-1.95-1.95",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#manual-synonym-lock_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#manual-synonym-lock_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 134.79,
  height: 58.644,
  x: 14.053,
  y: 9,
  fill: "#fff",
  rx: 2.938
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 35.974,
  height: 3.72,
  x: 22.4,
  y: 19.186,
  fill: "url(#manual-synonym-lock_svg__d)",
  rx: 1.86
}), /*#__PURE__*/React.createElement("rect", {
  width: 35.974,
  height: 3.72,
  x: 22.4,
  y: 30.423,
  fill: "url(#manual-synonym-lock_svg__e)",
  rx: 1.86
}), /*#__PURE__*/React.createElement("rect", {
  width: 28.048,
  height: 3.72,
  x: 22.4,
  y: 41.66,
  fill: "#D3D3D3",
  rx: 1.86
}), /*#__PURE__*/React.createElement("rect", {
  width: 28.048,
  height: 3.72,
  x: 22.4,
  y: 52.897,
  fill: "#D3D3D3",
  rx: 1.86
})), /*#__PURE__*/React.createElement("rect", {
  width: 21.6,
  height: 44.034,
  x: 65.261,
  y: 15.884,
  stroke: "#EDEEEF",
  strokeWidth: 0.417,
  rx: 3.13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E4246",
  d: "m72.99 21.909-1.782.672v.025l1.782.69v.63l-2.475-1.044v-.548l2.475-1.046zm4.186 1.536h-2.41v-.526h2.41zm0-1.152h-2.41v-.526h2.41zm1.778 1.012 1.783-.675v-.022l-1.783-.692v-.628l2.475 1.041v.55l-2.475 1.047zM74.956 34.036h-2.409v-.526h2.41zm0-1.152h-2.409v-.526h2.41zm1.779 1.012 1.783-.675V33.2l-1.783-.692v-.628l2.475 1.041v.55l-2.475 1.047zM72.99 43.091l-1.782.673v.024l1.782.69v.63l-2.475-1.043v-.548l2.475-1.047zm4.186 1.536h-2.41v-.526h2.41zm0-1.152h-2.41v-.526h2.41zm1.778 1.013 1.783-.675v-.022l-1.783-.692v-.63l2.475 1.043v.55l-2.475 1.047zM74.956 55.218h-2.409v-.526h2.41zm0-1.152h-2.409v-.525h2.41zm1.779 1.013 1.783-.675v-.022l-1.783-.692v-.629l2.475 1.042v.55L76.735 55.7z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 38.399,
  height: 3.339,
  x: 93.748,
  y: 19.757,
  fill: "#D3D3D3",
  rx: 1.67
}), /*#__PURE__*/React.createElement("rect", {
  width: 38.399,
  height: 3.339,
  x: 93.748,
  y: 30.613,
  fill: "#D3D3D3",
  rx: 1.67
}), /*#__PURE__*/React.createElement("rect", {
  width: 46.747,
  height: 3.72,
  x: 93.748,
  y: 41.469,
  fill: "url(#manual-synonym-lock_svg__f)",
  rx: 1.86
}), /*#__PURE__*/React.createElement("rect", {
  width: 38.399,
  height: 3.339,
  x: 93.748,
  y: 52.706,
  fill: "#D3D3D3",
  rx: 1.67
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#manual-synonym-lock_svg__g)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.404,
  height: 51.496,
  x: 59.565,
  y: 11.197,
  fill: "#008060",
  rx: 3.801,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m69.663 18.838-2.676 1.01v.036l2.676 1.035v.947L65.948 20.3v-.822l3.715-1.571zm5.979 2.305h-3.615v-.79h3.615zm0-1.729h-3.615v-.789h3.615zm2.367 1.52 2.676-1.013v-.033l-2.676-1.039v-.943l3.715 1.563v.826l-3.715 1.571zM72.612 32.774h-3.616v-.79h3.616zm0-1.729h-3.616v-.79h3.616zm2.367 1.52 2.676-1.013v-.033l-2.676-1.04v-.942l3.714 1.563v.826l-3.714 1.571zM69.663 42.1l-2.676 1.01v.036l2.676 1.035v.947l-3.715-1.567v-.822l3.715-1.571zm5.979 2.305h-3.615v-.79h3.615zm0-1.729h-3.615v-.789h3.615zm2.367 1.52 2.676-1.013v-.033l-2.676-1.04v-.942l3.715 1.563v.826l-3.715 1.571zM72.612 56.036h-3.616v-.79h3.616zm0-1.729h-3.616v-.789h3.616zm2.367 1.52 2.676-1.013v-.033l-2.676-1.039v-.943l3.714 1.563v.826L74.98 56.76z"
})))), /*#__PURE__*/React.createElement("rect", {
  width: 33.076,
  height: 12.5,
  x: 11.695,
  y: 74.418,
  fill: "#008060",
  rx: 3.285
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.702 83.48c-.53 0-.974-.244-1.2-.663h-.057v.6h-.723v-5.286h.751v2.088h.06c.202-.416.65-.667 1.17-.667.963 0 1.57.754 1.57 1.962 0 1.205-.61 1.966-1.57 1.966m-.216-3.254c-.629 0-1.023.496-1.027 1.292.004.796.395 1.288 1.027 1.288.635 0 1.016-.485 1.016-1.292 0-.8-.38-1.288-1.016-1.288m2.706 3.192v-3.803h.747v3.803zm.374-4.463a.483.483 0 0 1-.475-.49c0-.272.213-.492.475-.492s.475.22.475.493a.483.483 0 0 1-.475.489m2.322 2.245 1.508-1.585h.887l-1.564 1.63 1.67 2.172h-.923l-1.306-1.676-.331.315v1.362h-.751V78.13h.75v3.07zm3.206 2.218v-3.803h.747v3.803zm.373-4.463a.483.483 0 0 1-.475-.49c0-.272.213-.492.475-.492s.475.22.475.493a.483.483 0 0 1-.475.489m1.477 4.463v-3.803h.723v.604h.056c.185-.423.562-.678 1.135-.678.849 0 1.317.51 1.317 1.415v2.462h-.751v-2.274c0-.61-.266-.915-.82-.915-.556 0-.909.37-.909.964v2.225zm4.302 0v-3.803h.748v3.803zm.374-4.463a.483.483 0 0 1-.475-.49c0-.272.213-.492.475-.492s.475.22.475.493a.483.483 0 0 1-.475.489"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#manual-synonym-lock_svg__h)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.33,
  d: "m57.559 77.728 36.984-4.413L95.877 84.5l-36.983 4.414z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 37.975,
  height: 10.914,
  x: 57.041,
  y: 77.677,
  fill: "#fff",
  rx: 2.445,
  transform: "rotate(-6.805 57.04 77.677)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.975,
  height: 10.914,
  x: 57.041,
  y: 77.677,
  stroke: "#EDEEEF",
  strokeWidth: 0.435,
  rx: 2.445,
  transform: "rotate(-6.805 57.04 77.677)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202223",
  d: "M63.9 82.645c-.065-.543.387-.985 1.078-1.067.69-.082 1.177.184 1.3.717l-.578.07c-.084-.219-.32-.336-.663-.295-.337.04-.574.23-.545.47.021.182.19.28.53.315l.523.058c.599.065.901.283.955.733.068.576-.422 1.025-1.153 1.112-.728.087-1.243-.185-1.36-.721l.604-.072c.104.227.346.346.711.302.377-.044.624-.245.595-.49-.022-.182-.18-.283-.495-.32l-.549-.06c-.598-.068-.899-.297-.953-.753m6.972-1.71-.475 3.16-.627.076-.902-2.18-.048.006-.36 2.33-.621.074-1.209-2.96.613-.074.827 2.271.045-.005.35-2.411.58-.07.908 2.261.048-.005.266-2.401zm1 2.985-.365-3.061.602-.072.365 3.061zm-.128-3.629a.39.39 0 0 1-.429-.347.39.39 0 0 1 .335-.443.39.39 0 0 1 .43.351.39.39 0 0 1-.336.44m1.618 3.451-.365-3.061.582-.07.058.492.045-.005c.094-.362.379-.604.786-.653.42-.05.735.132.91.45l.047-.005c.115-.353.44-.611.865-.662.618-.074 1.023.257 1.099.895l.252 2.108-.605.073-.233-1.951c-.049-.413-.27-.592-.666-.545a.624.624 0 0 0-.57.718l.23 1.925-.594.071-.24-2.01c-.04-.345-.296-.529-.656-.486-.368.044-.61.378-.564.772l.224 1.872zm6.37-2.987c-.065-.542.386-.984 1.078-1.066.689-.083 1.177.184 1.3.717l-.579.069c-.083-.218-.32-.335-.662-.294-.338.04-.574.23-.546.47.022.182.19.279.531.315l.523.058c.598.065.9.283.954.733.069.576-.422 1.025-1.153 1.112-.728.087-1.242-.185-1.36-.721l.604-.072c.104.227.346.346.712.302.376-.045.623-.245.594-.49-.022-.182-.179-.283-.494-.32l-.549-.06c-.598-.068-.9-.297-.954-.753m5.65-1.552.365 3.061-.582.07-.058-.487-.047.006c-.108.366-.396.6-.86.656-.678.08-1.103-.288-1.19-1.008l-.237-1.987.605-.072.218 1.83c.06.495.287.707.731.654.49-.058.722-.38.664-.86l-.213-1.791zm1.254 2.955-.366-3.061.602-.072.365 3.061zm-.128-3.628a.39.39 0 0 1-.43-.348.39.39 0 0 1 .335-.442.39.39 0 0 1 .43.35.39.39 0 0 1-.335.44m1.375-.398.604-.072.093.775.663-.079.061.51-.663.078.187 1.575c.039.32.188.445.488.409.093-.011.146-.023.23-.042l.06.503a2 2 0 0 1-.326.07c-.672.08-.967-.123-1.037-.714l-.207-1.729-.486.059-.06-.51.486-.057z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#manual-synonym-lock_svg__i)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.34,
  d: "m99.471 72.995 47.123 5.096-1.357 12.553-47.123-5.095z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 48.299,
  height: 13.188,
  x: 98.964,
  y: 72.117,
  fill: "#fff",
  rx: 2.89,
  transform: "rotate(6.171 98.964 72.117)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 48.299,
  height: 13.188,
  x: 98.964,
  y: 72.117,
  stroke: "#EDEEEF",
  strokeWidth: 0.514,
  rx: 2.89,
  transform: "rotate(6.171 98.964 72.117)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202223",
  d: "M105.416 78.831c.07-.642.707-1.03 1.525-.942.815.088 1.306.525 1.307 1.17l-.685-.073c-.038-.273-.279-.471-.685-.515-.399-.043-.722.114-.752.396-.024.216.144.373.527.505l.587.205c.671.234.962.565.904 1.097-.073.681-.758 1.068-1.623.975-.861-.093-1.381-.543-1.375-1.192l.715.078c.06.289.307.49.74.537.445.048.783-.117.814-.407.023-.216-.131-.374-.484-.5l-.616-.214c-.671-.237-.957-.581-.899-1.12m8.482-.12-1.386 3.515-.742-.08-.46-2.748-.056-.006-1.033 2.586-.735-.08-.607-3.729.725.079.35 2.833.053.006 1.044-2.683.685.074.446 2.844.057.006.944-2.693zm.36 3.704.392-3.622.711.077-.391 3.622zm.815-4.212a.46.46 0 0 1-.401-.514.463.463 0 0 1 .503-.42.463.463 0 0 1 .401.517.463.463 0 0 1-.503.417m.948 4.403.391-3.622.689.074-.063.582.053.006c.204-.392.596-.595 1.078-.543.496.054.811.347.927.76l.057.006c.226-.376.669-.587 1.171-.533.732.08 1.11.567 1.028 1.323l-.269 2.494-.716-.078.25-2.308c.053-.489-.154-.753-.623-.804a.74.74 0 0 0-.847.676l-.246 2.278-.702-.076.257-2.378c.044-.409-.201-.688-.627-.734-.436-.047-.803.273-.854.739l-.239 2.215zm13.036-2.255-1.386 3.514-.742-.08-.46-2.748-.056-.006-1.034 2.586-.735-.079-.606-3.73.725.079.35 2.834.053.005 1.044-2.683.685.074.446 2.844.057.007.944-2.694zm2.027.764c-.529-.057-.938.276-1.039.837l1.829.198c.045-.571-.261-.978-.79-1.035m.66 2.202.689.074c-.226.628-.855.967-1.683.878-1.038-.112-1.596-.893-1.471-2.05.125-1.158.853-1.822 1.874-1.712 1.008.109 1.542.863 1.419 2l-.027.25-2.558-.276-.004.04c-.045.637.28 1.08.852 1.141.433.047.746-.077.909-.346m2.727.735c.539.058.975-.241 1.023-.69l.033-.303-.891-.039c-.502-.02-.747.125-.781.444-.035.326.227.546.616.588m-.248.582c-.699-.075-1.162-.553-1.09-1.215.07-.651.597-.975 1.464-.935l.987.05.034-.313c.041-.382-.188-.626-.677-.679-.399-.043-.691.074-.799.321l-.691-.075c.14-.614.768-.95 1.59-.86.908.097 1.371.605 1.288 1.37l-.267 2.474-.689-.074.055-.509-.056-.006c-.255.34-.674.503-1.149.451m2.857.249.391-3.622.689.074-.06.556.053.005c.141-.344.572-.56 1.044-.51.107.012.242.037.316.065l-.076.705a2 2 0 0 0-.395-.086c-.542-.059-.961.243-1.016.751l-.231 2.139z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB5",
  d: "M147 24.5c3.611 0 6.5-2.923 6.5-6.5 0 3.611 2.923 6.5 6.5 6.5a6.495 6.495 0 0 0-6.5 6.5c0-3.577-2.923-6.5-6.5-6.5M132 35.5c6.389 0 11.5-5.172 11.5-11.5 0 6.389 5.172 11.5 11.5 11.5-6.389 0-11.5 5.172-11.5 11.5 0-6.328-5.172-11.5-11.5-11.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "manual-synonym-lock_svg__b",
  width: 156.733,
  height: 80.589,
  x: 3.081,
  y: 1.035,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.007
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.486
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.364706 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18894_76806"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_18894_76806",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "manual-synonym-lock_svg__g",
  width: 49.439,
  height: 71.53,
  x: 49.547,
  y: 4.981,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.801
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.009
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.190625 0 0 0 0 0.184375 0 0 0 0 0.184375 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18894_76806"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_18894_76806",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "manual-synonym-lock_svg__h",
  width: 54.295,
  height: 31.576,
  x: 49.57,
  y: 65.327,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_18894_76806",
  stdDeviation: 3.994
})), /*#__PURE__*/React.createElement("filter", {
  id: "manual-synonym-lock_svg__i",
  width: 67.36,
  height: 36.529,
  x: 88.674,
  y: 63.555,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_18894_76806",
  stdDeviation: 4.72
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "manual-synonym-lock_svg__d",
  x1: 40.388,
  x2: 40.388,
  y1: 19.186,
  y2: 22.906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.865,
  stopColor: "#BABFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BBBFC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "manual-synonym-lock_svg__e",
  x1: 40.388,
  x2: 40.388,
  y1: 30.423,
  y2: 34.143,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.865,
  stopColor: "#BABFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BBBFC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "manual-synonym-lock_svg__f",
  x1: 117.121,
  x2: 117.121,
  y1: 41.469,
  y2: 45.189,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.865,
  stopColor: "#BABFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BBBFC3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "manual-synonym-lock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h160v100H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "manual-synonym-lock_svg__c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 134.79,
  height: 58.644,
  x: 14.053,
  y: 9,
  fill: "#fff",
  rx: 2.938
})))));
export { SvgManualSynonymLock as ReactComponent };
export default __webpack_public_path__ + "static/media/manual-synonym-lock.a8c1e3d3.svg";